import type { CollectionSummaryJSONObject } from '@ikegps/core-api';
import { ModalFormComponent, type ModalFormComponentCtx } from '../../components/modal.form/modal.form.component';
import { addStyles } from '../../components/theme';
import { T, Translate } from '../../i18n';
import { m, type MithrilVNode } from '../../mithril';
import { CollectionDuplicateModalCtrl } from './collection.duplicate.modal.ctrl';
import { CSS, Style } from './collection.duplicate.modal.style';

addStyles(Style);

export class CollectionDuplicateModal extends ModalFormComponent {
	private ctrl: CollectionDuplicateModalCtrl;

	constructor(ctx: ModalFormComponentCtx, collections: CollectionSummaryJSONObject[]) {
		super(ctx);
		this.ctrl = new CollectionDuplicateModalCtrl(collections);
	}

	get nodes(): MithrilVNode {
		return m('div', { className: CSS.container }, [
			m('div', { className: CSS.content }, [
				m('p', Translate(T.COLLECTION_DUPLICATE_CONFIRM, { count: this.ctrl.collections.length })),
			]),
		]);
	}

	override submit(): Promise<any> {
		return this.ctrl.duplicateCollections(null);
	}
}
